.ux-iws-shop-machine-check-flap {
    --machine-check-flap-width: 40px;
    --machine-check-flap-content-width: 320px;

    @media only screen and (min-width: $mobile) {
        --machine-check-flap-content-width: 400px;
    }

    position: relative;
    display: inline;

    &__flap {
        writing-mode: vertical-lr;
        transform: rotate(180deg);

        ux-icon {
            transform: rotate(90deg);
            vertical-align: baseline;
        }
    }

    &--open &__flap {
        display: none;
    }

    &__content {
        display: none;
    }

    &--open &__content {
        display: block;
    }

    &__layer {
        position: fixed;
        top: 50%;
        left: auto;
        right: 0;
        z-index: 600;
        width: var(--machine-check-flap-content-width);
        cursor: pointer;
        transition: transform 0.3s;
        transform: translate(
            calc(
                var(--machine-check-flap-content-width) -
                    var(--machine-check-flap-width)
            ),
            -50%
        );
    }

    &--open &__layer {
        transform: translate(0, -50%);
    }

    @media only screen and (min-width: $tablet) {
        &--initial &__layer {
            position: absolute;
            top: 50%;
        }

        &--initial &__layer {
            left: auto;
            right: 11px;
        }

        &--initial &__layer::after {
            position: absolute;
            content: " ";
            width: 0;
            height: 0;
            top: 50%;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
        }

        &--initial &__layer::after {
            left: auto;
            right: 0;
            border-left: 10px solid #fff;
            transform: translate(100%, -50%);
        }
    }
}
